import React, { useEffect, useState } from 'react';
import { Field, fieldClass } from './shared';

export default function InvoicePreset({ value, onChange, readonly }) {
  const isOffset = value?.selection === 'due_date_offset';
  const mode = isOffset ? value.days_offset < 0 ? 'before' : value.days_offset > 0 ? 'after' : 'today' : value?.selection || '';
  const [days, setDays] = useState(String(Math.abs(value?.days_offset || 5)));
  useEffect(() => { setDays(String(Math.abs(value?.days_offset || 5))); }, [value?.days_offset]);
  function changeMode(next) {
    if (['before', 'today', 'after'].includes(next)) onChange({ selection: 'due_date_offset', days_offset: next === 'today' ? 0 : next === 'before' ? -5 : 20, comparison: 'exact' });
    else onChange(next ? { selection: next } : null);
  }
  return <div className="flex flex-col gap-3">
    <Field label="Preset"><select disabled={readonly} className={fieldClass} value={mode} onChange={event => changeMode(event.target.value)}>
      <option value="">No preset (choose the filters manually)</option>
      <option value="before">Due in a number of days</option>
      <option value="today">Due today</option>
      <option value="after">Overdue by a number of days</option>
      <option value="oldest_overdue">Any overdue invoice</option>
      <option value="next_due">Any upcoming invoice</option>
      <option value="oldest_pending">Any pending invoice</option>
    </select></Field>
    {isOffset && mode !== 'today' && <div className="flex gap-3">
      <Field label="Match"><select className={fieldClass} disabled={readonly} value={value.comparison || 'exact'} onChange={event => onChange({ ...value, comparison: event.target.value })}>
        <option value="exact">Exactly</option><option value="at_least">At least</option>
      </select></Field>
      <Field label={mode === 'before' ? 'Days before due date' : 'Days overdue'}><input type="number" min={1} max={3650} step={1} disabled={readonly} className={fieldClass} value={days}
        onChange={event => {
          const next = event.target.value;
          if (next === '') { setDays(''); return; }
          const number = Number(next);
          if (!Number.isInteger(number) || number < 1 || number > 3650) return;
          setDays(String(number));
          onChange({ ...value, days_offset: mode === 'before' ? -number : number });
        }}
        onBlur={() => setDays(String(Math.abs(value.days_offset)))} />
      </Field>
    </div>}
    {value && <p className="text-xs text-gray-600">The preset sets the Status and Due date filters below, based on today's date. Changing either one manually removes the preset.</p>}
  </div>;
}
